import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";

export const ssrGetInitData = async (props: any) => {
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const teamMatch: any = matchPath(urlToMatch, {path: ['/teams/:teamName', '/teams/:teamName/brnd'], exact: true })
    const { teamName: id } = teamMatch?.params
    const teamUrl = id && `${EndpointsServer.geograffee}/api/Team/Get?idTeam=${id}`
    const teamResponse = id && await axios.get(teamUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    });
    const team = teamResponse?.data

    // console.log('ssrGetInitData!!!', {teamUrl, team});
    return {
        id,
        team,
        teamRu: team && API.toLang(team, 'ru'),
        teamEn: team && API.toLang(team, 'ru'),
        definedApp,
        // notFound: teamResponse?.is404
    }
}import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";

export const ssrGetInitData = async (props: any) => {
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const teamMatch: any = matchPath(urlToMatch, {path: ['/teams/:teamName', '/teams/:teamName/brnd'], exact: true })
    const { teamName: id } = teamMatch?.params
    const teamUrl = id && `${EndpointsServer.geograffee}/api/Team/Get?idTeam=${id}`
    const teamResponse = id && await axios.get(teamUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    });
    const team = teamResponse?.data

    // console.log('ssrGetInitData!!!', {teamUrl, team});
    return {
        id,
        team,
        teamRu: team && API.toLang(team, 'ru'),
        teamEn: team && API.toLang(team, 'ru'),
        definedApp,
        // notFound: teamResponse?.is404
    }
}